<template>
<div>
  <el-row
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(arrivalTransport).length && arrivalTransport.ibeData.type === 'FLIGHT'"
        :span="17"
        :key="arrivalTransport.id">
        <span
          style="display: table-cell; width: 22px">
          {{ totalCountTravelers }}x
        </span>
        <span
          style="display: table-cell">
          {{ $t('ibe.flight') }} {{ arrivalTransport.text.airport }} - {{ arrivalTransport.text.class }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(arrivalTransport).length && arrivalTransport.ibeData.type === 'FLIGHT' && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span v-if="arrivalTransport.ibeData.status === 'OK' && arrivalTransport.ibeData.price >= 0">
          {{ arrivalTransport.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
        <span v-else-if="arrivalTransport.ibeData.status === 'RQ' && arrivalTransport.ibeData.price >= 0">
          {{ arrivalTransport.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
        <span v-else-if="arrivalTransport.ibeData.status === 'OK'">
          {{ $t('ibe.inclusive') }}
        </span>
        <span v-else-if="arrivalTransport.ibeData.status === 'RQ'">
          {{ $t('ibe.request') }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(returnTransport).length && returnTransport.ibeData.type === 'FLIGHT'"
        :span="17"
        :key="returnTransport.id">
        <span
          style="display: table-cell; width: 22px">
          {{ totalCountTravelers }}x
        </span>
        <span
          style="display: table-cell">
          {{ $t('ibe.flight') }} {{ returnTransport.text.airport }} - {{ returnTransport.text.class }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(returnTransport).length && returnTransport.ibeData.type === 'FLIGHT' && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span v-if="returnTransport.ibeData.status === 'OK' && returnTransport.ibeData.price >= 0">
          {{ returnTransport.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
        <span v-else-if="returnTransport.ibeData.status === 'RQ' && returnTransport.ibeData.price >= 0">
          {{ returnTransport.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
        <span v-else-if="returnTransport.ibeData.status === 'OK'">
          {{ $t('ibe.inclusive') }}
        </span>
        <span v-else-if="returnTransport.ibeData.status === 'RQ'">
          {{ $t('ibe.request') }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row v-if="selectedUnits.length"
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col
        :span="17">
        <span
          style="display: table-cell; width: 22px">
          1x
        </span>
        <span v-if="selectedUnits[0].ibeData.kabNr != 0"
          style="display: table-cell">
          {{ selectedUnits[0].text.unit }} {{ selectedUnits[0].text.board }} {{ $t('ibe.text_cabin', {cabin: selectedUnits[0].ibeData.kabNr}) }}
        </span>
        <span v-else
          style="display: table-cell">
          {{ selectedUnits[0].text.unit }} {{ selectedUnits[0].text.board }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="selectedUnits[0].price > 0 && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span>
          {{ selectedUnits[0].price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(preProgram).length"
        :span="17">
        <span
          style="display: table-cell; width: 22px">
          {{ totalCountTravelers }}x
        </span>
        <span
          style="display: table-cell">
          {{ preProgram.text.name }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(preProgram).length && preProgram.ibeData.price > 0 && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span>
          {{ preProgram.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(postProgram).length"
        :span="17">
        <span
          style="display: table-cell; width: 22px">
          {{ totalCountTravelers }}x
        </span>
        <span
          style="display: table-cell">
          {{ postProgram.text.name }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(postProgram).length && postProgram.ibeData.price > 0 && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span>
          {{ postProgram.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(stopover).length"
        :span="17">
        <span
          style="display: table-cell; width: 22px">
          {{ stopover.count }}x
        </span>
        <span
          style="display: table-cell">
          {{ stopover.text.name }} - {{ stopover.text.board }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="Object.keys(stopover).length && stopover.text.price > 0 && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span>
          {{ stopover.text.price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <template v-for="section in travelServiceSections">
    <el-row v-if="section.items.length"
      :key="section.key + '_headline'">
      <el-col
        :span="24"
        class="list-headline">
        {{ $t(section.headline) }}
      </el-col>
    </el-row>
    <template v-for="(value, index) in section.items">
      <el-row
        type="flex"
        justify="space-between"
        :key="section.key + '_' + index">
        <transition
          name="el-zoom-in-top"
          mode="out-in"
          appear>
          <el-col
            :span="17"
            :key="value.id">
            <span
              style="display: table-cell; width: 22px">
              {{ totalCountTravelers }}x
            </span>
            <span
              style="display: table-cell">
              {{ value.text.name }}<template v-if="section.showKatName"> {{ value.text.katName }}</template>
            </span>
          </el-col>
        </transition>
        <transition
          name="el-zoom-in-top"
          mode="out-in"
          appear>
          <el-col v-if="!showBookActionLoader"
            :span="7"
            class="list-price">
            <span v-if="value.ibeData.price > 0">
              {{ value.ibeData.price | currencyFormat(object.ibeData.currency) }}
            </span>
            <span v-else-if="isPaidOnBoard(section, value) || value.ibeData.price === null">
              {{ $t('ibe.onBoard') }}
            </span>
            <span v-else-if="value.ibeData.price === 0">
              {{ $t('ibe.inclusive') }}
            </span>
          </el-col>
        </transition>
      </el-row>
      <el-row v-if="isPaidOnBoard(section, value) && infoText(value)"
        :key="section.key + '_' + index + '_info'">
        <el-col
          :span="24"
          class="list-info">
          {{ infoText(value) }}
        </el-col>
      </el-row>
    </template>
  </template>
  <el-row v-for="(value, index) in selectedTrainServices"
    type="flex"
    justify="space-between"
    :key="'travelService_' + index">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col
        :span="17"
        :key="value.id">
        <span
          style="display: table-cell; width: 22px">
          {{ totalCountTravelers }}x
        </span>
        <span
          style="display: table-cell">
          {{ value.text.katName }} {{ value.text.name }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="!showBookActionLoader && value.ibeData.price > 0"
        :span="7"
        class="list-price">
        <span>
          {{ value.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row v-for="(value, key) in services"
    type="flex"
    justify="space-between"
    :key="'service_' + key">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col
        :span="17"
        :key="availableServices[parseInt(key - 1)].id">
        <span
          style="display: table-cell; width: 22px">
          {{ parseInt(value.length) }}x
        </span>
        <span
          style="display: table-cell">
          {{ availableServices[parseInt(key - 1)].text.name }}
        </span>
      </el-col>
    </transition>
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="availableServices[parseInt(key - 1)].ibeData.price > 0 && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span>
          {{ availableServices[parseInt(key - 1)].ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row
    type="flex"
    justify="space-between">
    <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="idInsurance > 0"
        :span="17"
        :key="'insurance_' + idInsurance">
        <span
          style="display: table-cell; width: 22px">
          {{ totalCountTravelers }}x
        </span>
        <span
          style="display: table-cell">
          {{ insurance.text.name }} {{ insurance.text.priceText }}
        </span>
      </el-col>
    </transition>
     <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col v-if="idInsurance > 0 && insurance.ibeData.price > 0 && !showBookActionLoader"
        :span="7"
        class="list-price">
        <span>
          {{ insurance.ibeData.price | currencyFormat(object.ibeData.currency) }}
        </span>
      </el-col>
    </transition>
  </el-row>
  <el-row v-if="idInsurance === 0"
    type="flex"
    justify="space-between">
     <transition
      name="el-zoom-in-top"
      mode="out-in"
      appear>
      <el-col
        :span="20">
        <span
          style="display: table-cell; width: 22px">
        </span>
        <span
          style="display: table-cell">
          {{ $t('ibe.label_no_insurance') }}
        </span>
      </el-col>
    </transition>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListServices',
  computed: {
    ...mapGetters('booking', [
      'selectedUnits',
      'preProgram',
      'postProgram',
      'stopover',
      'services',
      'busServicesBook',
      'railServicesBook',
      'excursionServicesBook',
      'beverageServicesBook',
      'otherTravelServicesBook',
      'availableServices',
      'idInsurance',
      'insurance',
      'arrivalTransport',
      'returnTransport',
      'totalCountTravelers',
      'trainServices',
      'trainService',
      'showBookActionLoader',
      'ibeResponse',
      'object'
    ]),
    selectedTrainServices () {
      return this._filter(this.trainServices, value => {
        return this._indexOf(this.trainService, value.id) >= 0
      })
    },
    travelServiceSections () {
      return [
        { key: 'busService', headline: 'ibe.headline_busServices', items: this.busServicesBook, showKatName: true },
        { key: 'railService', headline: 'ibe.headline_railServices', items: this.railServicesBook, showKatName: true },
        { key: 'excursion', headline: 'ibe.headline_excursions', items: this.excursionServicesBook, showKatName: false },
        { key: 'beverage', headline: 'ibe.headline_beverageServices', items: this.beverageServicesBook, showKatName: true },
        { key: 'travelService', headline: 'ibe.headline_travelServices', items: this.otherTravelServicesBook, showKatName: false }
      ]
    }
  },
  methods: {
    // excursions without a price are paid on board, regardless of the price returned by the booking request
    isPaidOnBoard (section, value) {
      return section.key === 'excursion' && value.text.fromPrice === 0
    },
    // DaVinci info texts (e.g. price paid on board) returned by the booking request
    infoText (value) {
      const line = this._find(this.ibeResponse.serviceLines || [], item => {
        return item.idBookingCode === value.ibeData.idBookingCode
      })
      return line ? line.infoText : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.list-info {
  font-size: 0.85em;
  padding-left: 22px;
}

.list-headline {
  font-weight: bold;
  margin-top: 8px;
}
</style>
